export default {
  locations: {
    miraflores: {
      indicators: {
        cfpressure: { data: [], lastValue: null, lastUpdate: null, populate: false },
        pressure: { data: [], lastValue: null, lastUpdate: null, populate: false },
        temperature: { data: [], lastValue: null, lastUpdate: null, populate: false },
        cftemperature: { data: [], lastValue: null, lastUpdate: null, populate: false },
        slunt1: { data: [], lastValue: null, lastUpdate: null, populate: false },
        slunt2: { data: [], lastValue: null, lastUpdate: null, populate: false },
        battery1: { data: [], lastValue: null, lastUpdate: null, populate: false },
        battery2: { data: [], lastValue: null, lastUpdate: null, populate: false },
        cfflow: { data: [], lastValue: null, lastUpdate: null, populate: false },
        cfvolumen_current_day: { data: [], lastValue: null, lastUpdate: null, populate: false },
        cfvolumen_total_day: { data: [], lastValue: null, lastUpdate: null, populate: false }
      },
      lastUpdate: null,
      connect: false
    },
    mochileros: {
      indicators: {
        cfpressure: { data: [], lastValue: null, lastUpdate: null, populate: false },
        pressure: { data: [], lastValue: null, lastUpdate: null, populate: false },
        temperature: { data: [], lastValue: null, lastUpdate: null, populate: false },
        slunt1: { data: [], lastValue: null, lastUpdate: null, populate: false },
        slunt2: { data: [], lastValue: null, lastUpdate: null, populate: false },
        energy: { data: [], lastValue: null, lastUpdate: null, populate: false },
        cfflow: { data: [], lastValue: null, lastUpdate: null, populate: false },
        cfvolumen_current_day: { data: [], lastValue: null, lastUpdate: null, populate: false },
        cfvolumen_total_day: { data: [], lastValue: null, lastUpdate: null, populate: false }
      },
      lastUpdate: null,
      connect: false
    },
    valledetenza: {
      indicators: {
        cfpressure: { data: [], lastValue: null, lastUpdate: null, populate: false },
        pressure: { data: [], lastValue: null, lastUpdate: null, populate: false },
        temperature: { data: [], lastValue: null, lastUpdate: null, populate: false },
        cftemperature: { data: [], lastValue: null, lastUpdate: null, populate: false },
        slunt1: { data: [], lastValue: null, lastUpdate: null, populate: false },
        slunt2: { data: [], lastValue: null, lastUpdate: null, populate: false },
        battery1: { data: [], lastValue: null, lastUpdate: null, populate: false },
        battery2: { data: [], lastValue: null, lastUpdate: null, populate: false },
        cfflow: { data: [], lastValue: null, lastUpdate: null, populate: false },
        cfvolumen_current_day: { data: [], lastValue: null, lastUpdate: null, populate: false },
        cfvolumen_total_day: { data: [], lastValue: null, lastUpdate: null, populate: false }
      },
      lastUpdate: null,
      connect: false
    },
    paez: {
      indicators: {
        pressure: { data: [], lastValue: null, lastUpdate: null, populate: false },
        // temperature: { data: [], lastValue: null, lastUpdate: null, populate: false },
        slunt1: { data: [], lastValue: null, lastUpdate: null, populate: false },
        slunt2: { data: [], lastValue: null, lastUpdate: null, populate: false },
        energy: { data: [], lastValue: null, lastUpdate: null, populate: false },
        pulsos: { data: [], lastValue: null, lastUpdate: null, populate: false },
        volumen_total_hour: { data: [], lastValue: null, lastUpdate: null, populate: false },
        volumen_total_day: { data: [], lastValue: null, lastUpdate: null, populate: false },
        battery1: { data: [], lastValue: null, lastUpdate: null, populate: false },
        battery2: { data: [], lastValue: null, lastUpdate: null, populate: false }
      },
      lastUpdate: null,
      connect: false
    },
    umbita: {
      indicators: {
        pressure: { data: [], lastValue: null, lastUpdate: null, populate: false },
        temperature: { data: [], lastValue: null, lastUpdate: null, populate: false },
        slunt1: { data: [], lastValue: null, lastUpdate: null, populate: false },
        slunt2: { data: [], lastValue: null, lastUpdate: null, populate: false },
        pressure2: { data: [], lastValue: null, lastUpdate: null, populate: false },
        pressure3: { data: [], lastValue: null, lastUpdate: null, populate: false },
        pulsos: { data: [], lastValue: null, lastUpdate: null, populate: false },
        acumulate_pulsos: { data: [], lastValue: null, lastUpdate: null, populate: false },
        volumen_total_hour: { data: [], lastValue: null, lastUpdate: null, populate: false },
        volumen_total_day: { data: [], lastValue: null, lastUpdate: null, populate: false },
      },
      lastUpdate: null,
      connect: false
    }
  },
  notifications: []
}



// WEBPACK FOOTER //
// ./src/store/initialState.js